"use client";

import React, { ReactNode, useContext } from "react";
import { twMerge } from "tailwind-merge";

import Icon from "@/components/icon";
import { sidebarContext } from "@/context/sidebar-context";

function EditIcon({
  className,
  sidebarJsx,
  ...rest
}: {
  className?: string;
  sidebarJsx?: ReactNode | string;
}): ReactNode {
  const { setVal, setIsHide } = useContext(sidebarContext);

  return (
    <div
      onClick={() => {
        setVal(sidebarJsx);
        setIsHide(false);
      }}
      className={twMerge(
        "bg-secondary text-white hover:bg-white hover:text-secondary rounded-full h-8 flex items-center justify-center cursor-pointer w-8 absolute top-3 right-1 md:right-3 " +
          (className ?? ""),
      )}
      {...rest}
    >
      <Icon icon={"meeting-modif"} size={15}></Icon>
    </div>
  );
}

export default EditIcon;
